// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.glow-button:hover:not(:disabled) {
  background: linear-gradient(to right, #FFBBBB, #A8C1FF, #C5A8FF);
  transform: scale(1.05);
  animation: glow 1.5s ease-in-out infinite;
}

@keyframes glow {
  0% {
    box-shadow: 0 0 5px rgba(255, 187, 187, 0.8), 0 0 10px rgba(168, 193, 255, 0.6), 0 0 15px rgba(197, 168, 255, 0.4);
  }
  50% {
    box-shadow: 0 0 10px rgba(255, 187, 187, 1), 0 0 20px rgba(168, 193, 255, 0.8), 0 0 30px rgba(197, 168, 255, 0.6);
  }
  100% {
    box-shadow: 0 0 5px rgba(255, 187, 187, 0.8), 0 0 10px rgba(168, 193, 255, 0.6), 0 0 15px rgba(197, 168, 255, 0.4);
  }
}

.no-hover-bar .recharts-layer.recharts-bar-rectangle,
.no-hover-bar .recharts-layer.recharts-bar-rectangle:hover,
.no-hover-bar .recharts-layer.recharts-bar-rectangle:active,
.no-hover-bar .recharts-layer.recharts-bar-rectangle:focus {
  fill-opacity: 1 !important;
  fill: inherit !important;
  background: none !important;
  cursor: default !important;
  pointer-events: none !important;
}

.no-hover-bar .recharts-bar-rectangles,
.no-hover-bar .recharts-bar-rectangles:hover,
.no-hover-bar .recharts-bar-rectangles:active,
.no-hover-bar .recharts-bar-rectangles:focus {
  background: none !important;
  fill-opacity: 1 !important;
  pointer-events: none !important;
}

.no-hover-bar .recharts-layer.recharts-bar,
.no-hover-bar .recharts-layer.recharts-bar:hover,
.no-hover-bar .recharts-layer.recharts-bar:active,
.no-hover-bar .recharts-layer.recharts-bar:focus {
  background: none !important;
  fill-opacity: 1 !important;
  pointer-events: none !important;
}

.no-hover-bar .recharts-wrapper,
.no-hover-bar .recharts-wrapper:hover,
.no-hover-bar .recharts-surface,
.no-hover-bar .recharts-surface:hover {
  background: none !important;
  fill-opacity: 1 !important;
  pointer-events: auto !important;
}

.no-hover-bar .recharts-tooltip-wrapper,
.no-hover-bar .recharts-tooltip-wrapper:hover {
  pointer-events: auto !important;
}

.question-details-table {
  width: 100%;
  max-width: 1600px;
  min-width: 1200px;
  border-collapse: collapse;
  background: #fff;
  border-radius: 10px;
  border: 2px solid transparent;
  background-image: linear-gradient(#fff, #fff), linear-gradient(to right, #FFBBBB, #A8C1FF, #C5A8FF);
  background-origin: border-box;
  background-clip: padding-box, border-box;
  margin: 0 auto;
  display: table;
  table-layout: fixed;
  font-family: 'Roboto', sans-serif;
  max-height: 550px;
  overflow-y: auto;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: thin;
  scrollbar-color: #6B21A8 #f1f1f1;
}

.question-details-table::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}

.question-details-table::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 5px;
}

.question-details-table::-webkit-scrollbar-thumb {
  background: #6B21A8;
  border-radius: 5px;
  border: 2px solid #f1f1f1;
}

.question-details-table::-webkit-scrollbar-thumb:hover {
  background: #4a1575;
}

.question-details-table thead {
  position: sticky;
  top: 0;
  z-index: 1;
  background: linear-gradient(to right, #EFF6FF, #F3E8FF, #FEE7EF);
  font-family: 'Roboto', sans-serif;
}

.question-details-table thead th {
  padding: 10px;
  font-weight: bold;
  text-align: center;
  border: 1px solid #ddd;
  font-size: 13px;
  font-family: 'Roboto', sans-serif;
  color: #6B21A8;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.question-details-table thead th:nth-child(1) {
  width: 50%;
}

.question-details-table thead th:nth-child(2) {
  width: 12.5%;
}

.question-details-table thead th:nth-child(3) {
  width: 12.5%;
}

.question-details-table thead th:nth-child(4) {
  width: 12.5%;
}

.question-details-table thead th:nth-child(5) {
  width: 12.5%;
}

.question-details-table tbody {
  display: table-row-group;
  font-family: 'Roboto', sans-serif;
}

.question-details-table tr {
  display: table;
  width: 100%;
  table-layout: fixed;
  font-family: 'Roboto', sans-serif;
}

.question-details-table td, .question-details-table th {
  padding: 8px;
  border: 1px solid #ddd;
  font-size: 13px;
  font-family: 'Roboto', sans-serif;
  color: #333;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.question-details-table td:first-child {
  text-align: left;
  white-space: normal;
  word-wrap: break-word;
  width: 50%;
}

.view-button {
  background: none;
  border: none;
  color: #cc8888;
  padding: 2px;
  cursor: pointer;
  transition: color 0.3s ease, transform 0.3s ease;
  font-family: 'Roboto', sans-serif;
}

.view-button:hover {
  color: #b36666 !important;
  transform: scale(1.1);
  font-family: 'Roboto', sans-serif !important;
}

/* Container styles */
.test-result-container {
  padding: 2rem 2rem 0 2rem;
  background: linear-gradient(to right, #EFF6FF, #F3E8FF, #FEE7EF);
  font-family: 'Roboto', sans-serif;
  height: auto;
  overflow: hidden;
  min-height: 0;
}

.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background: linear-gradient(to right, #EFF6FF, #F3E8FF, #FEE7EF);
  font-family: 'Roboto', sans-serif;
}

.loading-text {
  font-size: 18px;
  color: #333;
  font-family: 'Roboto', sans-serif;
}

.error-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background: linear-gradient(to right, #EFF6FF, #F3E8FF, #FEE7EF);
  font-family: 'Roboto', sans-serif;
}

.error-text {
  font-size: 18px;
  color: #ff4d4f;
  margin-bottom: 20px;
  font-family: 'Roboto', sans-serif;
}

.test-name-header {
  text-align: center;
  margin-bottom: 20px;
  font-family: 'Roboto', sans-serif;
}

.test-name-header h3 {
  margin: 0;
  color: #333;
  font-family: 'Roboto', sans-serif;
}

.score-header {
  text-align: center;
  margin-bottom: 20px;
  font-family: 'Roboto', sans-serif;
}

.score-header h2 {
  color: #333;
  font-family: 'Roboto', sans-serif;
}

.main-content {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
  flex-wrap: wrap;
  gap: 20px;
  font-family: 'Roboto', sans-serif;
}

.charts-section {
  flex: 1 1;
  min-width: 300px;
  max-width: 600px;
  font-family: 'Roboto', sans-serif;
}

.charts-section h3 {
  color: #333;
  margin-bottom: 10px;
  font-family: 'Roboto', sans-serif;
}

.no-data-text {
  color: #333;
  text-align: center;
  font-family: 'Roboto', sans-serif;
}

.tables-section {
  flex: 1 1;
  min-width: 100px;
  max-width: 500px;
  margin-top: 100px;
  margin-bottom: 20px;
  margin-left: 220px;
  font-family: 'Roboto', sans-serif;
}

.section-table {
  max-height: 200px;
  overflow-y: auto;
  font-family: 'Roboto', sans-serif;
}

.bar-chart-section {
  margin-top: 20px;
  font-family: 'Roboto', sans-serif;
}

.table-base {
  width: 100%;
  border-collapse: collapse;
  background: #fff;
  border-radius: 20px;
  background-image: linear-gradient(#fff, #fff), linear-gradient(to right, #FFBBBB, #A8C1FF, #C5A8FF);
  background-origin: border-box;
  background-clip: padding-box, border-box;
  border: 2px solid transparent;
  font-family: 'Roboto', sans-serif;
}

.table-header {
  background: linear-gradient(to right, #EFF6FF, #F3E8FF, #FEE7EF);
  color: #6B21A8;
  font-family: 'Roboto', sans-serif;
}

.table-row-even {
  background: linear-gradient(to right, #FAFCFF, #FBF6FF, #FFF8FB);
  font-family: 'Roboto', sans-serif;
}

.table-row-odd {
  background-color: #FFFFFF;
  font-family: 'Roboto', sans-serif;
}

.metrics-table {
  margin-top: 60px;
  font-family: 'Roboto', sans-serif;
}

.legend-container {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-bottom: 2rem;
  font-family: 'Roboto', sans-serif;
}

.legend-box {
  font-size: 16px;
  font-family: 'Roboto', sans-serif;
}

.highlight-box {
  display: inline-block;
  background-color: #4CAF50;
  color: white;
  padding: 2px 10px;
  border-radius: 5px;
  margin-left: 6px;
  font-family: 'Roboto', sans-serif;
}

.question-details-section {
  margin-top: 30px;
  margin-bottom: 20px;
  font-family: 'Roboto', sans-serif;
}

.question-details-section h3 {
  color: #333;
  margin-bottom: 10px;
  font-family: 'Roboto', sans-serif;
}

.section-header-row {
  background-color: #e0e7ff;
  font-weight: bold;
  border-top: 2px solid #EFF6FF;
  font-family: 'Roboto', sans-serif;
}

.question-row-even {
  background: linear-gradient(to right, #FAFCFF, #FBF6FF, #FFF8FB);
  font-family: 'Roboto', sans-serif;
}

.question-row-odd {
  background: #FFFFFF;
  font-family: 'Roboto', sans-serif;
}

.question-text {
  color: #333;
  text-align: left;
  font-family: 'Roboto', sans-serif;
}

.answer-text {
  color: #333;
  text-align: center;
  font-family: 'Roboto', sans-serif;
}

.status-skipped {
  color: #ffa500 !important;
  font-weight: bold;
  text-align: center;
  font-family: 'Roboto', sans-serif;
}

.status-correct {
  color: green !important;
  font-weight: bold;
  text-align: center;
  font-family: 'Roboto', sans-serif;
}

.status-wrong {
  color: red !important;
  font-weight: bold;
  text-align: center;
  font-family: 'Roboto', sans-serif;
}

.back-button-container {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  margin-top: 2rem;
  margin-bottom: 2rem;
  width: 100%;
  font-family: 'Roboto', sans-serif;
}

.back-button {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 6px 16px;
  font-size: 14px;
  font-weight: 600;
  color: #6B21A8;
  text-transform: uppercase;
  letter-spacing: 1px;
  cursor: pointer;
  border-radius: 30px;
  border: 2px solid transparent;
  background-image: linear-gradient(#ffffff, #ffffff), linear-gradient(to right, #FFBBBB, #A8C1FF, #C5A8FF);
  background-origin: border-box;
  background-clip: padding-box, border-box;
  transition: all 0.4s ease;
  font-family: 'Roboto', sans-serif;
}

.back-button:hover {
  transform: scale(1.05);
  animation: glow 1.5s ease-in-out infinite;
  font-family: 'Roboto', sans-serif;
}

/* Table cell styles */
.td-base {
  padding: 8px;
  border: 1px solid #ddd;
  font-size: 13px;
  text-align: center;
  font-family: 'Roboto', sans-serif;
  color: #333;
}

.th-base {
  padding: 10px;
  font-weight: bold;
  text-align: center;
  border: 1px solid #ddd;
  font-size: 13px;
  font-family: 'Roboto', sans-serif;
  color: #6B21A8;
}

/* Left-align the first column (Section) in section-table */
.section-table .td-base:first-child {
  text-align: left !important;
  font-family: 'Roboto', sans-serif;
}

/* Left-align the first column (Metric) in metrics-table */
.metrics-table .td-base:first-child {
  text-align: left !important;
  font-family: 'Roboto', sans-serif;
}

/* Modal overlay styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0,0,0,0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  font-family: 'Roboto', sans-serif;
}`, "",{"version":3,"sources":["webpack://./src/pages/TestResultPage.css"],"names":[],"mappings":"AAAA;EACE,gEAAgE;EAChE,sBAAsB;EACtB,yCAAyC;AAC3C;;AAEA;EACE;IACE,kHAAkH;EACpH;EACA;IACE,iHAAiH;EACnH;EACA;IACE,kHAAkH;EACpH;AACF;;AAEA;;;;EAIE,0BAA0B;EAC1B,wBAAwB;EACxB,2BAA2B;EAC3B,0BAA0B;EAC1B,+BAA+B;AACjC;;AAEA;;;;EAIE,2BAA2B;EAC3B,0BAA0B;EAC1B,+BAA+B;AACjC;;AAEA;;;;EAIE,2BAA2B;EAC3B,0BAA0B;EAC1B,+BAA+B;AACjC;;AAEA;;;;EAIE,2BAA2B;EAC3B,0BAA0B;EAC1B,+BAA+B;AACjC;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,6BAA6B;EAC7B,mGAAmG;EACnG,6BAA6B;EAC7B,wCAAwC;EACxC,cAAc;EACd,cAAc;EACd,mBAAmB;EACnB,iCAAiC;EACjC,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,iCAAiC;EACjC,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,gEAAgE;EAChE,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,iCAAiC;EACjC,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,wBAAwB;EACxB,iCAAiC;AACnC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,eAAe;EACf,iCAAiC;EACjC,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,YAAY;EACZ,eAAe;EACf,gDAAgD;EAChD,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA,qBAAqB;AACrB;EACE,yBAAyB;EACzB,gEAAgE;EAChE,iCAAiC;EACjC,YAAY;EACZ,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,gEAAgE;EAChE,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,WAAW;EACX,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,gEAAgE;EAChE,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,SAAS;EACT,WAAW;EACX,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,iCAAiC;AACnC;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,mGAAmG;EACnG,6BAA6B;EAC7B,wCAAwC;EACxC,6BAA6B;EAC7B,iCAAiC;AACnC;;AAEA;EACE,gEAAgE;EAChE,cAAc;EACd,iCAAiC;AACnC;;AAEA;EACE,gEAAgE;EAChE,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;EACzB,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,6BAA6B;EAC7B,iCAAiC;AACnC;;AAEA;EACE,gEAAgE;EAChE,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,6BAA6B;EAC7B,yGAAyG;EACzG,6BAA6B;EAC7B,wCAAwC;EACxC,yBAAyB;EACzB,iCAAiC;AACnC;;AAEA;EACE,sBAAsB;EACtB,yCAAyC;EACzC,iCAAiC;AACnC;;AAEA,sBAAsB;AACtB;EACE,YAAY;EACZ,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,iCAAiC;EACjC,WAAW;AACb;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,iCAAiC;EACjC,cAAc;AAChB;;AAEA,2DAA2D;AAC3D;EACE,2BAA2B;EAC3B,iCAAiC;AACnC;;AAEA,0DAA0D;AAC1D;EACE,2BAA2B;EAC3B,iCAAiC;AACnC;;AAEA,yBAAyB;AACzB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,2BAA2B;EAC3B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,iCAAiC;AACnC","sourcesContent":[".glow-button:hover:not(:disabled) {\n  background: linear-gradient(to right, #FFBBBB, #A8C1FF, #C5A8FF);\n  transform: scale(1.05);\n  animation: glow 1.5s ease-in-out infinite;\n}\n\n@keyframes glow {\n  0% {\n    box-shadow: 0 0 5px rgba(255, 187, 187, 0.8), 0 0 10px rgba(168, 193, 255, 0.6), 0 0 15px rgba(197, 168, 255, 0.4);\n  }\n  50% {\n    box-shadow: 0 0 10px rgba(255, 187, 187, 1), 0 0 20px rgba(168, 193, 255, 0.8), 0 0 30px rgba(197, 168, 255, 0.6);\n  }\n  100% {\n    box-shadow: 0 0 5px rgba(255, 187, 187, 0.8), 0 0 10px rgba(168, 193, 255, 0.6), 0 0 15px rgba(197, 168, 255, 0.4);\n  }\n}\n\n.no-hover-bar .recharts-layer.recharts-bar-rectangle,\n.no-hover-bar .recharts-layer.recharts-bar-rectangle:hover,\n.no-hover-bar .recharts-layer.recharts-bar-rectangle:active,\n.no-hover-bar .recharts-layer.recharts-bar-rectangle:focus {\n  fill-opacity: 1 !important;\n  fill: inherit !important;\n  background: none !important;\n  cursor: default !important;\n  pointer-events: none !important;\n}\n\n.no-hover-bar .recharts-bar-rectangles,\n.no-hover-bar .recharts-bar-rectangles:hover,\n.no-hover-bar .recharts-bar-rectangles:active,\n.no-hover-bar .recharts-bar-rectangles:focus {\n  background: none !important;\n  fill-opacity: 1 !important;\n  pointer-events: none !important;\n}\n\n.no-hover-bar .recharts-layer.recharts-bar,\n.no-hover-bar .recharts-layer.recharts-bar:hover,\n.no-hover-bar .recharts-layer.recharts-bar:active,\n.no-hover-bar .recharts-layer.recharts-bar:focus {\n  background: none !important;\n  fill-opacity: 1 !important;\n  pointer-events: none !important;\n}\n\n.no-hover-bar .recharts-wrapper,\n.no-hover-bar .recharts-wrapper:hover,\n.no-hover-bar .recharts-surface,\n.no-hover-bar .recharts-surface:hover {\n  background: none !important;\n  fill-opacity: 1 !important;\n  pointer-events: auto !important;\n}\n\n.no-hover-bar .recharts-tooltip-wrapper,\n.no-hover-bar .recharts-tooltip-wrapper:hover {\n  pointer-events: auto !important;\n}\n\n.question-details-table {\n  width: 100%;\n  max-width: 1600px;\n  min-width: 1200px;\n  border-collapse: collapse;\n  background: #fff;\n  border-radius: 10px;\n  border: 2px solid transparent;\n  background-image: linear-gradient(#fff, #fff), linear-gradient(to right, #FFBBBB, #A8C1FF, #C5A8FF);\n  background-origin: border-box;\n  background-clip: padding-box, border-box;\n  margin: 0 auto;\n  display: table;\n  table-layout: fixed;\n  font-family: 'Roboto', sans-serif;\n  max-height: 550px;\n  overflow-y: auto;\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n  scrollbar-width: thin;\n  scrollbar-color: #6B21A8 #f1f1f1;\n}\n\n.question-details-table::-webkit-scrollbar {\n  width: 10px;\n  height: 10px;\n}\n\n.question-details-table::-webkit-scrollbar-track {\n  background: #f1f1f1;\n  border-radius: 5px;\n}\n\n.question-details-table::-webkit-scrollbar-thumb {\n  background: #6B21A8;\n  border-radius: 5px;\n  border: 2px solid #f1f1f1;\n}\n\n.question-details-table::-webkit-scrollbar-thumb:hover {\n  background: #4a1575;\n}\n\n.question-details-table thead {\n  position: sticky;\n  top: 0;\n  z-index: 1;\n  background: linear-gradient(to right, #EFF6FF, #F3E8FF, #FEE7EF);\n  font-family: 'Roboto', sans-serif;\n}\n\n.question-details-table thead th {\n  padding: 10px;\n  font-weight: bold;\n  text-align: center;\n  border: 1px solid #ddd;\n  font-size: 13px;\n  font-family: 'Roboto', sans-serif;\n  color: #6B21A8;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n}\n\n.question-details-table thead th:nth-child(1) {\n  width: 50%;\n}\n\n.question-details-table thead th:nth-child(2) {\n  width: 12.5%;\n}\n\n.question-details-table thead th:nth-child(3) {\n  width: 12.5%;\n}\n\n.question-details-table thead th:nth-child(4) {\n  width: 12.5%;\n}\n\n.question-details-table thead th:nth-child(5) {\n  width: 12.5%;\n}\n\n.question-details-table tbody {\n  display: table-row-group;\n  font-family: 'Roboto', sans-serif;\n}\n\n.question-details-table tr {\n  display: table;\n  width: 100%;\n  table-layout: fixed;\n  font-family: 'Roboto', sans-serif;\n}\n\n.question-details-table td, .question-details-table th {\n  padding: 8px;\n  border: 1px solid #ddd;\n  font-size: 13px;\n  font-family: 'Roboto', sans-serif;\n  color: #333;\n  text-align: center;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.question-details-table td:first-child {\n  text-align: left;\n  white-space: normal;\n  word-wrap: break-word;\n  width: 50%;\n}\n\n.view-button {\n  background: none;\n  border: none;\n  color: #cc8888;\n  padding: 2px;\n  cursor: pointer;\n  transition: color 0.3s ease, transform 0.3s ease;\n  font-family: 'Roboto', sans-serif;\n}\n\n.view-button:hover {\n  color: #b36666 !important;\n  transform: scale(1.1);\n  font-family: 'Roboto', sans-serif !important;\n}\n\n/* Container styles */\n.test-result-container {\n  padding: 2rem 2rem 0 2rem;\n  background: linear-gradient(to right, #EFF6FF, #F3E8FF, #FEE7EF);\n  font-family: 'Roboto', sans-serif;\n  height: auto;\n  overflow: hidden;\n  min-height: 0;\n}\n\n.loading-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100vh;\n  background: linear-gradient(to right, #EFF6FF, #F3E8FF, #FEE7EF);\n  font-family: 'Roboto', sans-serif;\n}\n\n.loading-text {\n  font-size: 18px;\n  color: #333;\n  font-family: 'Roboto', sans-serif;\n}\n\n.error-container {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  height: 100vh;\n  background: linear-gradient(to right, #EFF6FF, #F3E8FF, #FEE7EF);\n  font-family: 'Roboto', sans-serif;\n}\n\n.error-text {\n  font-size: 18px;\n  color: #ff4d4f;\n  margin-bottom: 20px;\n  font-family: 'Roboto', sans-serif;\n}\n\n.test-name-header {\n  text-align: center;\n  margin-bottom: 20px;\n  font-family: 'Roboto', sans-serif;\n}\n\n.test-name-header h3 {\n  margin: 0;\n  color: #333;\n  font-family: 'Roboto', sans-serif;\n}\n\n.score-header {\n  text-align: center;\n  margin-bottom: 20px;\n  font-family: 'Roboto', sans-serif;\n}\n\n.score-header h2 {\n  color: #333;\n  font-family: 'Roboto', sans-serif;\n}\n\n.main-content {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 20px;\n  flex-wrap: wrap;\n  gap: 20px;\n  font-family: 'Roboto', sans-serif;\n}\n\n.charts-section {\n  flex: 1;\n  min-width: 300px;\n  max-width: 600px;\n  font-family: 'Roboto', sans-serif;\n}\n\n.charts-section h3 {\n  color: #333;\n  margin-bottom: 10px;\n  font-family: 'Roboto', sans-serif;\n}\n\n.no-data-text {\n  color: #333;\n  text-align: center;\n  font-family: 'Roboto', sans-serif;\n}\n\n.tables-section {\n  flex: 1;\n  min-width: 100px;\n  max-width: 500px;\n  margin-top: 100px;\n  margin-bottom: 20px;\n  margin-left: 220px;\n  font-family: 'Roboto', sans-serif;\n}\n\n.section-table {\n  max-height: 200px;\n  overflow-y: auto;\n  font-family: 'Roboto', sans-serif;\n}\n\n.bar-chart-section {\n  margin-top: 20px;\n  font-family: 'Roboto', sans-serif;\n}\n\n.table-base {\n  width: 100%;\n  border-collapse: collapse;\n  background: #fff;\n  border-radius: 20px;\n  background-image: linear-gradient(#fff, #fff), linear-gradient(to right, #FFBBBB, #A8C1FF, #C5A8FF);\n  background-origin: border-box;\n  background-clip: padding-box, border-box;\n  border: 2px solid transparent;\n  font-family: 'Roboto', sans-serif;\n}\n\n.table-header {\n  background: linear-gradient(to right, #EFF6FF, #F3E8FF, #FEE7EF);\n  color: #6B21A8;\n  font-family: 'Roboto', sans-serif;\n}\n\n.table-row-even {\n  background: linear-gradient(to right, #FAFCFF, #FBF6FF, #FFF8FB);\n  font-family: 'Roboto', sans-serif;\n}\n\n.table-row-odd {\n  background-color: #FFFFFF;\n  font-family: 'Roboto', sans-serif;\n}\n\n.metrics-table {\n  margin-top: 60px;\n  font-family: 'Roboto', sans-serif;\n}\n\n.legend-container {\n  display: flex;\n  justify-content: center;\n  gap: 20px;\n  margin-bottom: 2rem;\n  font-family: 'Roboto', sans-serif;\n}\n\n.legend-box {\n  font-size: 16px;\n  font-family: 'Roboto', sans-serif;\n}\n\n.highlight-box {\n  display: inline-block;\n  background-color: #4CAF50;\n  color: white;\n  padding: 2px 10px;\n  border-radius: 5px;\n  margin-left: 6px;\n  font-family: 'Roboto', sans-serif;\n}\n\n.question-details-section {\n  margin-top: 30px;\n  margin-bottom: 20px;\n  font-family: 'Roboto', sans-serif;\n}\n\n.question-details-section h3 {\n  color: #333;\n  margin-bottom: 10px;\n  font-family: 'Roboto', sans-serif;\n}\n\n.section-header-row {\n  background-color: #e0e7ff;\n  font-weight: bold;\n  border-top: 2px solid #EFF6FF;\n  font-family: 'Roboto', sans-serif;\n}\n\n.question-row-even {\n  background: linear-gradient(to right, #FAFCFF, #FBF6FF, #FFF8FB);\n  font-family: 'Roboto', sans-serif;\n}\n\n.question-row-odd {\n  background: #FFFFFF;\n  font-family: 'Roboto', sans-serif;\n}\n\n.question-text {\n  color: #333;\n  text-align: left;\n  font-family: 'Roboto', sans-serif;\n}\n\n.answer-text {\n  color: #333;\n  text-align: center;\n  font-family: 'Roboto', sans-serif;\n}\n\n.status-skipped {\n  color: #ffa500 !important;\n  font-weight: bold;\n  text-align: center;\n  font-family: 'Roboto', sans-serif;\n}\n\n.status-correct {\n  color: green !important;\n  font-weight: bold;\n  text-align: center;\n  font-family: 'Roboto', sans-serif;\n}\n\n.status-wrong {\n  color: red !important;\n  font-weight: bold;\n  text-align: center;\n  font-family: 'Roboto', sans-serif;\n}\n\n.back-button-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 20px;\n  margin-top: 2rem;\n  margin-bottom: 2rem;\n  width: 100%;\n  font-family: 'Roboto', sans-serif;\n}\n\n.back-button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 6px 16px;\n  font-size: 14px;\n  font-weight: 600;\n  color: #6B21A8;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  cursor: pointer;\n  border-radius: 30px;\n  border: 2px solid transparent;\n  background-image: linear-gradient(#ffffff, #ffffff), linear-gradient(to right, #FFBBBB, #A8C1FF, #C5A8FF);\n  background-origin: border-box;\n  background-clip: padding-box, border-box;\n  transition: all 0.4s ease;\n  font-family: 'Roboto', sans-serif;\n}\n\n.back-button:hover {\n  transform: scale(1.05);\n  animation: glow 1.5s ease-in-out infinite;\n  font-family: 'Roboto', sans-serif;\n}\n\n/* Table cell styles */\n.td-base {\n  padding: 8px;\n  border: 1px solid #ddd;\n  font-size: 13px;\n  text-align: center;\n  font-family: 'Roboto', sans-serif;\n  color: #333;\n}\n\n.th-base {\n  padding: 10px;\n  font-weight: bold;\n  text-align: center;\n  border: 1px solid #ddd;\n  font-size: 13px;\n  font-family: 'Roboto', sans-serif;\n  color: #6B21A8;\n}\n\n/* Left-align the first column (Section) in section-table */\n.section-table .td-base:first-child {\n  text-align: left !important;\n  font-family: 'Roboto', sans-serif;\n}\n\n/* Left-align the first column (Metric) in metrics-table */\n.metrics-table .td-base:first-child {\n  text-align: left !important;\n  font-family: 'Roboto', sans-serif;\n}\n\n/* Modal overlay styles */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0,0,0,0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n  font-family: 'Roboto', sans-serif;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
